<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
    <kendo-grid-component
      :spanish="spanish"
      :dataResult='kendo.dataResult'
      :kendo="kendo"
      :loading='isGeneralLoading'
      :selectedField="selectedField"
      @datastatechange='dataStateChange'
      @columnreorder='columnReorder'
      @rowclick='openPath'
      @columnssubmit='onColumnsSubmit'
      @sortchange='sortChange'
      @filterchange='filterChange'
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange">
    </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="getAccionesPosibles !== null && getAccionesPosibles.length > 0 && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" :ariaHidden="true"/>
                {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="hasModuleImportaciones" mode='primary' :text="$t('app.import')" icon='import' @click='toggleImport' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode="primary" v-if="!isNotice" :text="$t('configurations.new_user')" icon="plus" @click="goToNewUser" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <import-generic-dialog
        :vuexNamespace="vuexnamespace"
        :dialogOpen="showModalImport" 
        @toggleDialog="toggleImport" 
        @applyDialog="applyImport"
        @downloadTemplate="downloadTemplate"
        header="Importación de Usuarios" 
        />      
      <BaseElDialog
        title="Borrar usuario"
        :visible.sync="showModal"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-user')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDeleteUser }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-user">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <BaseElDialog
          title="Vincular grupos"
          :visible.sync="showModalLinkGroups"
          @open="handleOpenModalDialog([
            'container-handleOpenModal-link-groups-body',
            'container-handleOpenModal-link-groups',
            ])"
          :close-on-click-modal="!isSelectDropdownOpen"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
            <div 
              class="overflow-x-hidden"
              ref="container-handleOpenModal-link-groups-body"
              :style="{'height':heightContainerSelect}"
              >
              <el-form
                ref="ruleForm"
              >
                <div class="lg:mb-2">
                  <div>
              
                    <AccessibleElSelect
                      prop="selectedGroups"
                      v-model="listaGroupsSelected"
                      :isMultiple="true"
                      :options="listaGroupsGrouping"
                      id-prefix="users"
                      :isDisabled="isLoadingSelect"
                      :group="true"
                    >
                      <template #label>
                        {{ $t('app.groups') }}
                      </template>
                    </AccessibleElSelect>

                  </div>
                </div>
              </el-form>
            </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-link-groups">
              <base-button class="w-full" v-if="isAllSelected" @click="handleUnSelectAll" mode="secondary-phantom-blue" :text="$t('app.unselect_all')" :disabled="!isLoadedData || isLoadingSelect" :loading="isLoadingSelect"/>
              <base-button class="w-full" v-if="!isAllSelected" :disabled="!isLoadedData || isLoadingSelect || isEmptyList" @click="handleSelectAll" mode="secondary-phantom-blue" :text="$t('app.select_all')" :loading="isLoadingSelect"/>
              <div class="w-48"></div>
              <base-button class="w-full" @click="showModalLinkGroups = false" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
                :loading="isLoadingSelect"
                :disabled="isLoadingSelect"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyLinkHandler(); showModalLinkGroups = false}"
                :loading="isLoadingSelect"
                :disabled="isLoadingSelect"/>
            </div>
          </template>
      </BaseElDialog>
      <BaseElDialog
          title="Desvincular Estados"
          :visible.sync="showModalUnlinkStatuses"
          @open="handleOpenModalDialog('container-handleOpenModal-unlink-statuses')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkStatuses }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-unlink-statuses">
              <base-button class="w-full" @click="showModalUnlinkStatuses = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {unlinkStatusesHandler(); showModalUnlinkStatuses = false}"/>
            </div>
          </template>
      </BaseElDialog>
        <BaseElDialog
          title="Vincular Estados"
          :visible.sync="showModalLinkStatuses"
          @open="handleOpenModalDialog([
            'container-handleOpenModal-link-statuses-body',
            'container-handleOpenModal-link-statuses',
            ])"
          :close-on-click-modal="!isSelectDropdownOpen"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <div 
              class="overflow-x-hidden"
              ref="container-handleOpenModal-link-statuses-body"
              :style="{'height':heightContainerSelect}"
              >
              <el-form
                ref="ruleForm"
              >
                <div class="lg:mb-2">
                  <div>
                    <AccessibleElSelect
                      v-model="listaStatusesSelected"
                      prop="selectedGroups"
                      :options="listaStatusesForAccessibleSelect"
                      :isMultiple="true"
                      :isDisabled="isLoadingSelectStatuses"
                      @visible-change="onExpand"
                      @change="onChangeInput"
                      id-prefix="users-statuses"
                    >
                      <template slot="label">{{$t('configurations.status')}}</template>
                    </AccessibleElSelect>
                  </div>
                </div>
              </el-form>
            </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-link-statuses">
              <base-button class="w-full" v-if="isAllStatusesSelected" @click="handleUnSelectAllStatuses" mode="secondary-phantom-blue" :text="$t('app.unselect_all')" :disabled="!isLoadedDataStatuses || isLoadingSelectStatuses" :loading="isLoadingSelectStatuses"/>
              <base-button class="w-full" v-if="!isAllStatusesSelected" :disabled="!isLoadedDataStatuses || isLoadingSelectStatuses || isEmptyStatusesList" @click="handleSelectAllStatuses" mode="secondary-phantom-blue" :text="$t('app.select_all')" :loading="isLoadingSelectStatuses"/>
              <div class="w-48"></div>
              <base-button class="w-full" @click="showModalLinkStatuses = false" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
                :loading="isLoadingSelectStatuses"
                :disabled="isLoadingSelectStatuses"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyLinkStatusesHandler(); showModalLinkStatuses = false}"
                :loading="isLoadingSelectStatuses"
                :disabled="isLoadingSelectStatuses"/>
            </div>
          </template>
      </BaseElDialog>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/UsersFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import ImportGenericDialog from '@/components/ImportGenericDialog.vue'

import { getUsers } from '@/services/configurations/getUsers'
import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
import { downloadUsersUexcel } from '@/services/configurations/downloadUsersUexcel'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import { deleteUser } from '@/services/configurations/deleteUser'
import { changeStateUsers } from '@/services/configurations/changeStateUsers'
import { recoveryPassUsers } from '@/services/configurations/recoveryPassUsers'
import { getAllStatus } from '@/services/configurations/status/getAllStatus'
import { linkUsersToStatuses } from '@/services/configurations/status/linkUsersToStatuses'
import { unlinkUsersToStatuses } from '@/services/configurations/status/unlinkUsersToStatuses'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'

import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'
import { linkUsersGroupsMultiple } from '@/services/configurations/groups/linkUsersGroupsMultiple'

import { importUsers } from '@/services/configurations/imports/importUsers'
import { downloadTemplateUsers } from '@/services/configurations/imports/downloadTemplateUsers'

import { resetOTP } from '@/services/configurations/resetOTP'

import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { dropdownState } from '@/state/dropdownState'

export default {
  name: 'vista-usuarios',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    KendoGridComponent,
    CreateSearchDialog,
    // UsersLinkGroupsMultipleDialog,
    BaseElDialog,
    ImportGenericDialog,
    AccessibleElSelect,
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      idVista: 9,
      // Links
      listaGroups: [],
      listaStatuses: [],
      listaGroupsSelected: [],
      listaStatusesSelected: [],
      showModalLinkGroups: false,
      showModalLinkStatuses: false,
      showModalUnlinkStatuses: false,
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false,
      isLoadedDataStatuses: false,
      loadingActionSelectStatuses: false,
      loadingActionUnSelectStatuses: false,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // Import
      showModalImport: false,
      // All
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: i18n.t('app.users'),
        icon: 'config',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'users',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAcciones: [
        { IdAccion: 100, Descripcion: i18n.t('groups.link') },
        // { IdAccion: 101, Descripcion: i18n.t('groups.unlink') },
        { IdAccion: 200, Descripcion: i18n.t('configurations.link_statuses') },
        { IdAccion: 201, Descripcion: i18n.t('configurations.unlink_statuses') },
        { IdAccion: 300, Descripcion: 'Activar' },
        { IdAccion: 301, Descripcion: 'Desactivar' },
        { IdAccion: 400, Descripcion: 'Email recuperación de contraseña' },
        { IdAccion: 500, Descripcion: 'Restablecer doble factor' },
        { IdAccion: 0, Descripcion: 'Borrar' }
      ],
      processMessageDeleteUser: '¿Estás seguro que deseas borrar los usuarios seleccionados?',
      processMessageUnlinkStatuses: '¿Estás seguro que deseas desvincular todos los estados a los usuarios seleccionados?',
      isNotice: false,
      noticeType: ''
    }
  },
  computed: {
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasModuleImportaciones']
    },
    listaGroupsGrouping () {
      if (!this.isEmptyList) {
        const options = []
        this.listaGroups.forEach(x => {
          if (options.filter(y => y.label === x.group).length === 0) {
            options.push(
              { label: x.group, options: [] }
            )
          }
        })
        this.listaGroups.forEach(x => {
          const index = options.map(x => x.label).indexOf(x.group)
          options[index].options.push(
            {
              id: x.id,
              name: x.value,
            }
          )
        })
        return options
      }
      return []
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    hasModuleDobleFactor () {
      return this.$store.getters['auth/hasModuleDobleFactor']
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isSelectDropdownOpen () {
      return dropdownState.isAnyDropdownOpen
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isEmptyList: function () {
      return this.listaGroups === undefined || this.listaGroups === null || this.listaGroups.length === 0
    },
    isEmptyStatusesList: function () {
      return this.listaStatuses === undefined || this.listaStatuses === null || this.listaStatuses.length === 0
    },
    listaStatusesForAccessibleSelect () {
      return this.listaStatuses.map(status => ({
        id: status.idEstado,
        value: status.idEstado,
        name: status.Descripcion
      }))
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isLoadingSelectStatuses: function () {
      return this.loadingActionSelectStatuses || this.loadingActionSelectStatuses
    },
    isAllSelected: function () {
      if (this.listaGroups.length === this.listaGroupsSelected.length) return true
      else return false
    },
    isAllStatusesSelected: function () {
      if (this.listaStatuses.length === this.listaStatusesSelected.length) return true
      else return false
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    selectIcon: function (action) {
      return (action) =>
        action === 0 ? 'trash' 
          : action === 100 ? 'groupadd'
            // : action === 101 ? 'groupremove'
            : action === 200 ? 'link'
              : action === 300 ? 'check'
                : action === 301 ? 'cross'
                  : action === 400 ? 'lock'
                    : action === 500 ? 'retrydoblefactor'
                      : 'unlink'
    },
    getAccionesPosibles () {
      let listaAccionesFinal = this.listaAcciones.slice()
      // Al seleccionar:
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        const idEmpresa = this.selected[0].idEmpresa
        // Usuarios de diferentes clientes => Quitamos vincular grupos
        if (this.selected.length !== this.selected.filter(x => x.idEmpresa === idEmpresa).length ||
          this.selected.length !== this.selected.filter(x => x.Rol !== 'AdminDistribuidor' && x.Rol !== 'SuperAdminDistribuidor' && x.Rol !== 'SuperAdministrador').length) {
          listaAccionesFinal.shift()
        }
        // Acciones de estados para usuarios sin VerTodoEstados
        if (this.selected.length !== this.selected.filter(x => x.VerTodoEstados === false).length||
          this.selected.length !== this.selected.filter(x => x.Rol !== 'AdminDistribuidor' && x.Rol !== 'SuperAdminDistribuidor' && x.Rol !== 'SuperAdministrador').length) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 200 && x.IdAccion !== 201)
        }
        if (!this.hasModuleDobleFactor) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 500)
        }
      }
      return listaAccionesFinal
    },
    firstUserSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) return this.selected[0].IdUsuario
      return 0
    }
  },
  watch: {
    $route (to, from) {
      this.checkIsNotice(to, from)
      this.updateOnRouteChange(to, from)
      // this.routerChangeHandler()
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    },
    showModalLinkGroups: async function (val, oldVal) {
      this.isLoadedData = false
      try {
        if (val === true) {
          const data = await getGroupsSimple({ idUsuario: this.firstUserSelected })
          if (data.blnError === true) {
            this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
          } else {
            data.Respuesta.forEach(row => {
              this.listaGroups.push({ id: row.IdGrupo, value: row.Nombre, group: row.Tipo })
            })
          }
        } else {
          this.listaGroups = []
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.isLoadedData = true
      }
    },
  },
  created: async function () {
    if (this.$route.meta && this.$route.meta.notice !== undefined && this.$route.meta.notice !== null) {
      this.isNotice = true
      this.noticeType = this.$route.meta.notice
      if (this.noticeType === 'usuariospasswordcaducar') {
        this.header.title = i18n.t('app.usuariospasswordcaducar')
      } else {
        console.error('NoticeType no encontrado o no registrado')
      }
    } else {
      this.isNotice = false
      this.noticeType = ''
    }
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.downloadStatuses()
    this.data = await this.applyFilters()
  },
  methods: {
    // onSelectTemplateChange (event) {
    //   console.log('onSelectTemplateChange event:', event)
    // },
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    toggleImport () {
      this.showModalImport = !this.showModalImport
    },
    applyImport: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importUsers(file, { idCliente: form.idCliente })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImport() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplate: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateUsers()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-usuarios.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            const cliente = { label: 'Cliente', value: filter.data.label }
            filters.empresa = cliente
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      // console.log('onChangeInput', 'onChangeInput')
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    checkIsNotice: function (to, from) {
      if (to.meta && to.meta.notice !== undefined) {
        this.isNotice = true
        this.noticeType = to.meta.notice
        if (this.noticeType === 'usuariospasswordcaducar') {
          this.header.title = i18n.t('app.usuariospasswordcaducar')
        } else {
          console.error('NoticeType no encontrado o no registrado')
        }
      } else {
        this.isNotice = false
        this.noticeType = ''
      }
    },
    applyLinkHandler: async function () {
      this.showModalLinkGroups = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idGrupos: [], idUsuarios: [] }
        payload.idGrupos = this.listaGroupsSelected
        payload.idUsuarios = this.selected.map(x => x.IdUsuario)
        const response = await linkUsersGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Vinculado correctamente', 'success')
        }
        this.listaGroupsSelected = []
        this.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyLinkStatusesHandler: async function () {
      this.showModalLinkStatuses = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idEstados: [], idUsuarios: [] }
        payload.idEstados = this.listaStatusesSelected
        payload.idUsuarios = this.selected.map(x => x.IdUsuario)
        const response = await linkUsersToStatuses(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Vinculado correctamente', 'success')
        }
        this.listaStatusesSelected = []
        this.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadStatuses: async function () {
      this.isLoadedDataStatuses = false
      try {
        const data = await getAllStatus()
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          this.listaStatuses = data.respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.isLoadedDataStatuses = true
      }
    },
    toggleDialogLinkGroups: function () {
      if (this.showModalLinkGroups && this.isLoadingSelect) return
      this.listaGroupsSelected = []
      this.showModalLinkGroups = !this.showModalLinkGroups
    },
    toggleDialogLinkStatuses: function () {
      if (this.showModalLinkStatuses && this.isLoadingSelectStatuses) return
      this.listaStatusesSelected = []
      this.showModalLinkStatuses= !this.showModalLinkStatuses
    },
    handleSelectAll: async function () {
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.listaGroups.forEach(element => {
        setTimeout(() => {
          this.listaGroupsSelected.push(element.id)
          if (this.listaGroupsSelected.length === this.listaGroups.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.listaGroupsSelected.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.listaGroupsSelected.pop()
          if (this.listaGroupsSelected.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    },
    handleSelectAllStatuses: async function () {
      await this.handleUnSelectAllStatuses()
      this.loadingActionSelectStatuses = true
      this.listaStatuses.forEach(element => {
        setTimeout(() => {
          this.listaStatusesSelected.push(element.idEstado)
          if (this.listaStatusesSelected.length === this.listaStatuses.length) {
            this.loadingActionSelectStatuses = false
            this.loadingActionUnSelectStatuses = false
          }
        }, 100)
      })
    },
    handleUnSelectAllStatuses: async function () {
      this.loadingActionUnSelectStatuses = true
      const staticLength = this.listaStatusesSelected.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.listaStatusesSelected.pop()
          if (this.listaStatusesSelected.length === 0) this.loadingActionUnSelectStatuses = false
        }, 100)
      }
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    openPath: function (event) {
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.Usuario)
      this.$router.push({ name: 'configurations/users/details', params: { id: event.dataItem.IdUsuario, noticeType: this.noticeType } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)      
      // Fix temporal para mostrar columnas después de reordenar
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
      // Old sin fix
      // this.kendo.columns = options.columns
    },
    // columnReorder: function (options) {      
    //   // Permitir al usuario desplazar las columnas visibles
    //   this.assignOrder()
    //   const optionsOrdered = Array.from(options.columns).sort((a, b) => {
    //     return a.orderIndex > b.orderIndex ? 1 : a.orderIndex < b.orderIndex ? -1 : 0
    //   })
    //   this.kendo.columns = this.kendo.columns
    //     .map(
    //       (el) => {
    //         if (el.hidden === undefined || el.hidden === false) {
    //           (el.orderIndex = optionsOrdered.find(
    //             (find) => find.field === el.field
    //           ).orderIndex)
    //         }
    //         return el
    //       }
    //     )
    // },
    // assignOrder: function () {
    //   this.kendo.columns
    //     .forEach((map, index) => (map.orderIndex = index))
    // },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        conectado: data.conectado ? data.conectado.value : null,
        nombre: data.name ? data.name.value : null,
        email: data.email ? data.email.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        rol: data.role ? data.role.value : null,
        activos: data.Activo ? data.Activo.value : null,
        tipoAutenticacion: data.tipoAuth ? data.tipoAuth.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        passwordCaducado: this.isNotice
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
        const payload = { order: objOrder.order, grupos: objColumnas }
        if (this.hasSelected) {
          const selectedIDs = this.selected.map(x => x.IdUsuario)
          payload.listaIDs = selectedIDs
        }
        const response = await downloadUsersUexcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'usuarios.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    // getColumnsGroupExcel: function () {
    //   const columns = this.kendo.columns.filter(x => {
    //     if ((x.hidden === false || x.hidden === undefined) && x.field !== 'selected' && x.field !== undefined) return x
    //   }).sort((a, b) => {
    //     return a.orderIndex - b.orderIndex
    //   }).map(x => {
    //     return { columna: x.field, group: false }
    //   })
    //   this.kendo.group.forEach(group => {
    //     columns.map(x => {
    //       if (x.columna === group.field) x.group = true
    //       return x
    //     })
    //   })
    //   return columns
    // },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    updateOnRouteChange: async function (to, from) {
      await this.applyFilters()
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        conectado: data.conectado ? data.conectado.value : null,
        nombre: data.name ? data.name.value : null,
        email: data.email ? data.email.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        rol: data.role ? data.role.value : null,
        activos: data.Activo ? data.Activo.value : null,
        tipoAutenticacion: data.tipoAuth ? data.tipoAuth.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        passwordCaducado: this.isNotice
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getUsers(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 0) { // borrar
        this.deleteUser()
      } else if (this.selectedAction.IdAccion === 100) { // Link grupos
        this.toggleDialogLinkGroups()
      } else if (this.selectedAction.IdAccion === 201) { // Unink statuses
        this.unlinkStatuses()
      } else if (this.selectedAction.IdAccion === 200) { // Link statuses
        this.toggleDialogLinkStatuses()
      } else if (this.selectedAction.IdAccion === 300) { // Activar
        this.activeHandler(true)
      } else if (this.selectedAction.IdAccion === 301) { // Desactivar
        this.activeHandler(false)
      } else if (this.selectedAction.IdAccion === 400) { // Recuperación de contraseña
        this.recoveryPassHandler()
      } else if (this.selectedAction.IdAccion === 500) { // Reestablecer otp
        this.resetOTPHandler()
      } else {
        console.error('Acción desconocida')
      }
    },
    recoveryPassHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsUsuario: [],
        }
        for (const element of this.selected) {
          payload.idsUsuario.push(element.IdUsuario)
        }
        const response = await recoveryPassUsers(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    resetOTPHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsUsuario: [],
        }
        for (const element of this.selected) {
          payload.idsUsuario.push(element.IdUsuario)
        }
        const response = await resetOTP(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    activeHandler: async function (valueActive) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idUsuarios: [],
          Activo: valueActive,
        }
        for (const element of this.selected) {
          payload.idUsuarios.push(element.IdUsuario)
        }
        const response = await changeStateUsers(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    deleteUser: async function () {
      this.showModal = !this.showModal
    },
    unlinkStatuses: async function () {
      this.showModalUnlinkStatuses = !this.showModalUnlinkStatuses
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    goToNewUser: function () {
      this.$router.push({ name: 'configurations/users/details', params: { id: -1 } })
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsUsuario: []
        }
        for (const element of this.selected) {
          payload.idsUsuario.push(element.IdUsuario)
        }
        const response = await deleteUser(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    unlinkStatusesHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push(element.IdUsuario)
        }
        const response = await unlinkUsersToStatuses(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
